import React from 'react';
import { Tag } from 'primereact/tag';

const TYPE_LABELS = {
    pendingReport: 'Reporte pendiente',
    overduePlanned: 'Visita vencida',
    longRunning: 'Duración anormal',
    draftAgenda: 'Agenda en borrador',
    noPlannedVisits: 'Sin visitas'
};

const AttentionPanel = ({ alerts }) => {
    const items = alerts?.items || [];

    return (
        <section className="surface-card border-round p-3 shadow-1 ventas-attention-panel" aria-labelledby="ventas-attention-title">
            <div className="flex align-items-center justify-content-between gap-2 flex-wrap mb-3">
                <div>
                    <h3 id="ventas-attention-title" className="mt-0 mb-1">Requiere atención</h3>
                    <p className="text-color-secondary m-0">Pendientes operativos visibles dentro de Ventas.</p>
                </div>
                <Tag value={`${items.length} ${items.length === 1 ? 'alerta' : 'alertas'}`} severity={items.length ? 'warning' : 'success'} />
            </div>

            {items.length ? (
                <div className="ventas-alert-list">
                    {items.map((item, index) => (
                        <article key={`${item.type}-${item.visitId || item.agendaId || item.agentId}-${index}`} className={`ventas-alert ventas-alert--${item.severity || 'info'}`}>
                            <div className="flex align-items-start justify-content-between gap-2 flex-wrap">
                                <div>
                                    <strong>{item.title}</strong>
                                    <div className="text-sm text-color-secondary mt-1">{item.agentName} · {item.description}</div>
                                </div>
                                <Tag value={TYPE_LABELS[item.type] || item.type} severity={item.severity === 'danger' ? 'danger' : item.severity === 'warning' ? 'warning' : 'info'} />
                            </div>
                        </article>
                    ))}
                </div>
            ) : (
                <div className="ventas-empty-state">
                    <i className="pi pi-check-circle" aria-hidden="true" />
                    <span>No hay pendientes operativos para esta semana.</span>
                </div>
            )}
        </section>
    );
};

export default AttentionPanel;
